import React from 'react';
import _ from 'lodash';

import { IRosterShift } from '../../types';
import { WorkerShiftCard } from './WorkerShiftCard';

interface WorkerItemsListProps {
  shifts: IRosterShift[][];
  refreshData?: () => void;
}

export const WorkerItemsList = ({ shifts, refreshData }: WorkerItemsListProps) => {
  return (
    <>
      {shifts.map((shiftGroup, rowIdx) =>
        shiftGroup.map((shift, shiftIdx) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <WorkerShiftCard shift={shift} key={shiftIdx} refreshData={refreshData} rowIndex={rowIdx} />
        )),
      )}
    </>
  );
};
